<div class="login-container" *ngIf="this.showLogin">
  <div class="form-container card">
    <div class="logo">
      <img src="assets/images/accutrax-logo-black.png" alt="accutrax Logo" />
    </div>

    <app-login-form (formData)="login($event)"></app-login-form>
    <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>
    <a class="forgot-password" [routerLink]="['../forgot-password']"
      >Forgot password?</a
    >
  </div>
</div>
